// Thin os-core wrapper around the @os/people web page. Routed from
// App.tsx at /workspace/people. The real page lives in the @os/people
// sibling module (resolved via sibling-link in dev, registry in prod).
import PeopleDashboard from '@os/people/web/pages/workspace/PeopleDashboard'

export default function PeopleWorkspacePage() {
  return <PeopleDashboard />
}
